import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React from 'react';
export const Feedback = /*#__PURE__*/ React.forwardRef(({ componentClass: Component = 'div', className, type = 'success', tooltip = false, ...props }, ref)=>/*#__PURE__*/ _jsx(Component, {
        ...props,
        ref: ref,
        className: classNames(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
Feedback.displayName = 'Feedback';
